import { NavbarItem, NavbarSubItem } from '../../shared/navbar/types';
import navbarConfig from '../../shared/navbar/navbar-config';

type ExternalAppConfig = NavbarItem | NavbarSubItem | null;

// eslint-disable-next-line import/prefer-default-export
export function findExternalAppConfig(pathname: string, isExternalDashboardEnabled: boolean,
  isSecurityGatewayEnabled: boolean, isXmsMenusEnabled = true, isNetworkTopologyEnabled: boolean,
  isAlarmFeatureEnabled: boolean,
  isAlarmNotificationProfileEnabled: boolean,
  externalDashboardId?: string,
  systemHealthDashboardId?: string,
  aggLicensesDashboardId?: string,
  xcipioLicensesDashboardId?: string): ExternalAppConfig {
  const navbarConfiguration = navbarConfig(isExternalDashboardEnabled, isSecurityGatewayEnabled, isXmsMenusEnabled, isNetworkTopologyEnabled,
    isAlarmFeatureEnabled, isAlarmNotificationProfileEnabled,
    externalDashboardId, systemHealthDashboardId, aggLicensesDashboardId, xcipioLicensesDashboardId);

  let externalAppConfig: ExternalAppConfig = null;

  navbarConfiguration.forEach((itemConfig) => {
    if (itemConfig.children?.length) {
      itemConfig.children.forEach((subitemConfig) => {
        if (subitemConfig.route === pathname) {
          externalAppConfig = subitemConfig;
        }
      });
    } else if (itemConfig.route === pathname) {
      externalAppConfig = itemConfig;
    }
  });

  return externalAppConfig;
}
